baseOptions